module.exports = __webpack_public_path__ + "img/emoji_09.d2e802a3.png";